import { config } from "../config";

type EarlyResult = { ok: true; data: unknown } | { ok: false; status: number };
type EarlyEntry = { promise: Promise<EarlyResult>; startedAt: number; claimedAt?: number };
declare global {
  interface Window {
    __YESTV_EARLY__?: { environment: string; resources: Record<string, EarlyEntry> };
  }
}

export class PreloadError extends Error {
  constructor(public status: number) { super("Startup response unavailable"); }
}

// A one-time handoff of the current navigation's request, not a data cache.
// The brief reuse window also covers React's development StrictMode remount.
export function takePreloadedJson(endpoint: string, signal: AbortSignal, fresh = false): Promise<unknown> | undefined {
  if (fresh || signal.aborted || window.__YESTV_EARLY__?.environment !== config.environment) return;
  const entry = window.__YESTV_EARLY__.resources[new URL(endpoint, location.href).href];
  if (!entry || performance.now() - entry.startedAt > 30000 || entry.claimedAt !== undefined && performance.now() - entry.claimedAt > 250) return;
  entry.claimedAt ??= performance.now();
  return entry.promise.then(result => {
    if (signal.aborted) throw new DOMException("Aborted", "AbortError");
    if (!result.ok) throw new PreloadError(result.status);
    return result.data;
  });
}
